export default __webpack_public_path__ + "static/media/icon_provider_languages.6669047a.svg";